var _style, _desc, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "other - services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.000000, 11.016480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.694777, 0.913268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.6,29.8l-10.2-9.6c-0.6-0.6-1.9-1.1-2.9-1.1h-5.9c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2 c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1-0.1-0.3-0.1-0.4-0.1h-5.9c-1,0-2.3,0.5-2.9,1.1l-10.2,9.6c-0.6,0.6-0.7,1.6-0.1,2.3l17.3,19.6 c1.4,1.6,3.6,1.6,5,0l17.3-19.6C55.3,31.5,55.3,30.4,54.6,29.8z M41.6,20.3c0.6,0,1.5,0.3,1.9,0.7l10.2,9.6c0.1,0.1,0.1,0.2,0.1,0.3 c0,0,0,0-0.1,0h-7.2c-0.1-0.9-0.4-1.8-1-2.4l-5.7-7c-0.4-0.5-0.9-0.9-1.5-1.2H41.6z M35.4,50.9c-0.2,0.3-0.3,0.5-0.4,0.6 c-0.1-0.1-0.3-0.3-0.4-0.6l-9.3-17.7c-0.2-0.3-0.3-0.7-0.3-1h20.2c0,0.4-0.1,0.7-0.3,1L35.4,50.9z M24.9,30.9 c0.1-0.7,0.3-1.3,0.7-1.7l5.7-7c0.7-0.9,2.3-1.6,3.6-1.9c1.3,0.2,2.9,1,3.6,1.9l5.7,7c0.4,0.5,0.6,1.1,0.7,1.7H24.9z M16.4,30.6 L26.6,21c0.4-0.4,1.3-0.7,1.9-0.7h3.3c-0.6,0.4-1.1,0.8-1.5,1.2l-5.7,7c-0.5,0.7-0.9,1.5-1,2.4h-7.2c0,0,0,0,0,0 C16.3,30.8,16.3,30.7,16.4,30.6z M17,32.1h6.5c0.1,0.5,0.2,1.1,0.4,1.5l8.5,16.1L17,32.1z M37.6,49.7l8.5-16c0.2-0.4,0.4-1,0.4-1.5 H53L37.6,49.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/objects.c19b29ef.svg";
export { ForwardRef as ReactComponent };